'use client';
import React from 'react';
import Script from 'next/script';

const MatomoAnalytics = () => {
  if (process.env.APP_ENV === 'production') {
    return (
      <Script
        id={'matomoAnalyzer'}
        async={true}
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `var _paq = window._paq || [];
            /* tracker methods like "setCustomUrl" can be called before "trackPageView" */
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            (function() {
              var u="//${process.env.MATOMO_URL}/";
              _paq.push(['setTrackerUrl', u+'matomo.php']);
              _paq.push(['setSiteId', '${process.env.MATOMO_SITE_ID}']);
              var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
              g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
            })();` }}
      />
    );
  }

  return null;
};

export default MatomoAnalytics;
